import { createContext } from 'react';

export const ClientInfoLoadingContext = createContext();
